import { EPaginationActionTypes } from '../../actions/pagination';
import { EPromosActionTypes } from '../../actions/promos';
import { mapSeoData } from '../../mappers';
import { TReduxActions } from '../../types/redux';
import { ISeoData } from '../../types/seoData';

const defaultState: ISeoData = {
  metaDescription: '',
  pageDescription: '',
  title: '',
  h1: '',
  markedList: {
    items: [],
  },
  promoCategoryDetails: null,
};

export function seoDataReducer(state: ISeoData = defaultState, action: TReduxActions) {
  if (action.type === EPromosActionTypes.Success || action.type === EPaginationActionTypes.Success) {
    return mapSeoData(action.payload);
  }

  return state;
}
